import { FC } from 'react';
import { Button, Alert, Card, CardGroup, CardImg } from 'reactstrap';
import { HomeWrapper } from './Home.styled';
import home2 from './../../resources/home/home-2.png';
import home3 from './../../resources/home/home-3.jpg';
import home4 from './../../resources/home/home-4.jpg';
import home5 from './../../resources/home/home-5.jpg';
import EmbedYoutube from '../utils/EmbedYoutube/EmbedYoutube';
import CommentSection from '../utils/CommentSection/CommentSection';

interface HomeProps { }

const Home: FC<HomeProps> = () => (
  <HomeWrapper>
    <header className="entry-header">
      <h1 className="entry-title" itemProp="headline">Empower Your Career Path with Complete Knowledge in Java Programming</h1>
    </header>
    <div className="entry-content clear" itemProp="text">
      <figure className="aligncenter size-large is-resized is-style-rounded">
        <img decoding="async" width="1024" height="576" src={home2} alt="" style={{ width: '100%', height: 'auto' }} sizes="(max-width: 1024px) 100vw, 1024px" />
      </figure>
      <h4 className="text-align-justify">
        <strong>The most powerful thing in the world is knowledge because true knowledge helps a person to bloom. It helps us to convert our ideas into reality and to reach the success that we desire in our life. Knowledge gives us a vision of our future and what we can do in it.</strong>
      </h4>

      <CardGroup>
        <Card>
          <CardImg alt="" src={home3} top width="100%" />
        </Card>
        <Card>
          <CardImg alt="" src={home4} top width="100%" />
        </Card>
        <Card>
          <CardImg alt="" src={home5} top width="100%" />
        </Card>
      </CardGroup>

      <br />
      <p className="text-align-justify">Welcome to LetsUnderstandJava, the ultimate destination for mastering the Java programming language! Our mission is to guide you through Java’s core concepts, from basic syntax to advanced techniques, ensuring you build a strong foundation and gain practical experience.</p>
      <p className="text-align-justify">We break down complex Java concepts into easy-to-understand lessons, making learning engaging and effective. Join us on your journey to becoming a Java pro—explore our tutorials, interview questions, and connect with fellow learners. </p>
      <p className="text-align-justify">Ready to start your coding adventure? Dive in and unlock the power of Java with us today!</p>
      <br />
      <Alert color='light'>
        <p className="quote"><strong>We promise to offer you the knowledge in programming that will help you build your career on your own.</strong></p>
      </Alert>
      <br />
      <h3 className="has-text-align-center" style={{ color: '#1e293b' }}><em>Upskill Yourself Today With The Following Free Udemy Courses:</em></h3>
      <br />
      <div style={{ justifyContent: 'space-evenly', display: 'flex', flexWrap: 'wrap' }}>
        <Button className="course"><a href="https://www.udemy.com/course/master-the-basics-of-spring-integration-and-its-components/?couponCode=E194A32105C5458D5947">Spring Integration</a></Button>
        <Button className="course"><a href="https://www.udemy.com/course/dynamic-programming-made-easy">Dynamic Programming</a></Button>
        <Button className="course"><a href="https://www.udemy.com/course/mastering-java-stream-api">Java Stream API</a></Button>
        <Button className="course"><a href="https://www.udemy.com/course/top-10-java-interview-programs/?couponCode=EBE65F7FA87822F8B070">Java Interview Programs</a></Button>
      </div>
      <br />
      <div style={{ justifyContent: 'space-evenly', display: 'flex', flexWrap: 'wrap' }}>
        <Button className="course"><a href="https://www.udemy.com/course/apache-kafka-a-complete-beginner-guide-for-event-streaming/">Apache Kafka</a></Button>
        <Button className="course"><a href="https://www.udemy.com/course/all-about-react-from-scratch/?couponCode=4A46308C638EB8C387E9">React from Scratch</a></Button>
        <Button className="course"><a href="https://www.udemy.com/course/hibernate-basics/?couponCode=8600F7AD59EF55F9FF06">Hibernate Basics</a></Button>
      </div>
      <br />
      <div style={{ justifyItems: 'center' }}>
        <ul className="text-align-left">
          <li className="related-link"><a href="https://pn6.c7f.myftpupload.com/why-learn-java/">Why Learn Java?</a></li>
          <li className="related-link"><a href="https://pn6.c7f.myftpupload.com/lets-get-started/">Let’s get started with Java</a></li>
          <li className="related-link"><a href="https://pn6.c7f.myftpupload.com/java-youtube-video-tutorials/">Video Tutorials to help understand Java better</a></li>
        </ul>
      </div>
      <br />
    </div>
    <EmbedYoutube videoType="video" videoList={["9mDxG2M5PGs"]} />
    <CommentSection />
  </HomeWrapper>
);

export default Home;
